import React from "react";
import PropTypes from "prop-types";
import ReactImageMagnify from "react-image-magnify";
import browser from "web/script/utils/browser";
import styles from "./product-gallery-image.css";

const longPressDuration = 500;

function ZoomImage({ image }) {
    return (
        <div>
            <ReactImageMagnify
                {...{
                    smallImage: {
                        alt: image.altText,
                        isFluidWidth: true,
                        src: browser.retina ? image.gallery_image_2x : image.gallery_image
                    },
                    largeImage: {
                        alt: image.altText,
                        src: browser.retina ? image.gallery_image_3x : image.gallery_image_2x,
                        width: browser.retina ? 1560 : 1040,
                        height: browser.retina ? 1215 : 810
                    },
                    isHintEnabled: true,
                    shouldHideHintAfterFirstActivation: false,
                    enlargedImagePosition: "over",
                    pressDuration: longPressDuration
                }}
            />
        </div>
    );
}

ZoomImage.propTypes = {
    image: PropTypes.shape({
        gallery_image: PropTypes.string.isRequired,
        gallery_image_2x: PropTypes.string.isRequired,
        gallery_image_3x: PropTypes.string.isRequired,
        alt_text: PropTypes.string.isRequired
    })
};

function NormalImage({ image }) {
    return (
        <div className={styles.normalImageWrapper}>
            <img
                className={styles.normalImage}
                alt={image.altText}
                src={browser.retina ? image.large_url_2x : image.large_url}
            />
        </div>
    );
}

NormalImage.propTypes = {
    image: PropTypes.shape({
        large_url: PropTypes.string.isRequired,
        large_url_2x: PropTypes.string.isRequired,
        alt_text: PropTypes.string.isRequired
    })
};

function Image({ isZoom, image }) {
    if (isZoom) {
        return <ZoomImage image={image} />;
    }
    return <NormalImage image={image} />;
}

export default Image;

Image.propTypes = {
    isZoom: PropTypes.bool,
    image: PropTypes.shape({
        gallery_image: PropTypes.string,
        gallery_image_2x: PropTypes.string,
        gallery_image_3x: PropTypes.string,
        large_url: PropTypes.string,
        large_url_2x: PropTypes.string,
        alt_text: PropTypes.string.isRequired
    }),
    retailerLink: PropTypes.string
};

Image.defaultProps = {
    isZoom: false
};
